import { getFirestore, doc, getDoc } from "firebase/firestore";
import getUserUID from "../../shared/components/getUserUID";

const getCompleteUserData = async () => {
  try {
    const userUID = await getUserUID();
    if (!userUID) {
      return null;
    }

    const db = getFirestore();
    const userDocRef = doc(db, "registeredUsers", userUID);
    const docSnapshot = await getDoc(userDocRef);

    if (docSnapshot.exists()) {
      const userData = docSnapshot.data();
      return {
        uid: userUID,
        ...userData,
      };
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export default getCompleteUserData;
